import React from "react";
import Select from "react-select";
import { useAddressContext } from "../contexts/address.context";

function SelectAddressInput() {
  const { selectOptions, selectedAddress, addresses, setSelectedAddress } = useAddressContext();

  if (!addresses || addresses.length === 0) return null;
  return (
    <div className=" small-12 medium-6">
      <div className="resources-label address-title-text">Select Address</div>
      <Select
        name="filter-state"
        id="filter-state"
        placeholder="Type and Select"
        value={selectedAddress}
        onChange={setSelectedAddress}
        options={selectOptions()}
      />
    </div>
  );
}

export default SelectAddressInput;
